import React from 'react';

var InitialBlockEnvironment = {
  environment: 'prod'
};
var BlockEnvironmentContext = /*#__PURE__*/React.createContext(InitialBlockEnvironment);
var BlockEnvironmentProvider = function BlockEnvironmentProvider(_ref) {
  var children = _ref.children,
    environment = _ref.environment;
  var value = {
    environment: environment
  };
  return /*#__PURE__*/React.createElement(BlockEnvironmentContext.Provider, {
    value: value
  }, children);
};
var useBlockEnvironment = function useBlockEnvironment() {
  return React.useContext(BlockEnvironmentContext);
};

export { BlockEnvironmentProvider, useBlockEnvironment };
